"use client";

import { useState } from "react";
import Image from "../common/image/image";

const RateCardTooltip = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <button
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      className="apr-info-icon relative"
    >
      <Image
        src="/information-icon.svg"
        alt="Info-Icon"
        className="h-4 w-4"
        width={24}
        height={24}
      />
      {showTooltip && (
        <div className="absolute left-1/2 top-full z-10 mt-2 w-56 -translate-x-1/2 rounded-md bg-gray-800 p-2 text-sm text-white shadow-lg">
          APR, or Annual Percentage Rate, is the total cost of borrowing money
          for your mortgage—it includes both the interest rate and any lender
          fees, giving you a complete picture of what you'll pay over time.
        </div>
      )}
    </button>
  );
};

export default RateCardTooltip;
